import _pure from "recompose/pure";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '@nextiva/next-ui';
import cx from 'classnames';

var MultiSelectItem =
/*#__PURE__*/
function (_Component) {
  _inherits(MultiSelectItem, _Component);

  function MultiSelectItem() {
    var _ref;

    var _temp, _this;

    _classCallCheck(this, MultiSelectItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _possibleConstructorReturn(_this, (_temp = _this = _possibleConstructorReturn(this, (_ref = MultiSelectItem.__proto__ || Object.getPrototypeOf(MultiSelectItem)).call.apply(_ref, [this].concat(args))), Object.defineProperty(_assertThisInitialized(_this), "state", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: {
        isHovered: false
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleClick", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        var _this$props = _this.props,
            item = _this$props.item,
            index = _this$props.index;

        _this.props.onToggleItem(item, index);
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleMouseEnter", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          isHovered: true
        });
      }
    }), Object.defineProperty(_assertThisInitialized(_this), "handleMouseLeave", {
      configurable: true,
      enumerable: true,
      writable: true,
      value: function value() {
        _this.setState({
          isHovered: false
        });
      }
    }), _temp));
  }

  _createClass(MultiSelectItem, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          item = _props.item,
          index = _props.index,
          isSortable = _props.isSortable,
          blockName = _props.blockName;
      var isHovered = this.state.isHovered;
      var itemClassName = cx(_defineProperty({}, "".concat(blockName, "__mark--sortable"), isSortable), "".concat(blockName, "__mark"));
      return React.createElement("div", {
        key: index,
        className: "nx-table__multiselect-checkbox-container",
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave
      }, React.createElement(Checkbox, {
        onChange: this.handleClick,
        checked: item.checked
      }), React.createElement("div", {
        className: itemClassName
      }, React.createElement("span", {
        title: item.label,
        className: "".concat(blockName, "__text"),
        onClick: this.handleClick
      }, item.label), isSortable && isHovered && React.createElement("i", {
        className: "".concat(blockName, "__icon icon-custom-drag")
      })));
    }
  }]);

  return MultiSelectItem;
}(Component);

Object.defineProperty(MultiSelectItem, "propTypes", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    blockName: PropTypes.string,
    onToggleItem: PropTypes.func,
    item: PropTypes.shape({
      label: PropTypes.string.isRequired,
      checked: PropTypes.bool.isRequired
    }).isRequired,
    index: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    isSortable: PropTypes.bool
  }
});
Object.defineProperty(MultiSelectItem, "defaultProps", {
  configurable: true,
  enumerable: true,
  writable: true,
  value: {
    onToggleItem: function onToggleItem() {},
    blockName: 'nx-table__multiselect-item'
  }
});
export default _pure(MultiSelectItem);